import { render } from "./OtherWork.vue?vue&type=template&id=41bed51a&scoped=true"
import script from "./OtherWork.vue?vue&type=script&lang=js"
export * from "./OtherWork.vue?vue&type=script&lang=js"

import "./OtherWork.vue?vue&type=style&index=0&id=41bed51a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bed51a"]])

export default __exports__